import { useState, forwardRef } from "react";

import { DayOneData } from "./../data/data";

const DayOne = forwardRef((props, ref) => {
  const [data] = useState(DayOneData);
  return (
    <div className="content" ref={ref}>
      <h1 className="heading-tertiary">Day 1</h1>
      <div className="cards">
        {data.map((item) => {
          return (
            <div className="card" key={item.id}>
              <div className="card__header">
                <h1 className="card__title">{item.title}</h1>
                <h2 className="card__subtitle">{item.speaker}</h2>
              </div>
              <div className="card__actions">
                <a
                  href={item.ytURL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="card__link"
                >
                  Talk
                </a>
                {item.slidesURL ? (
                  <a
                    href={item.slidesURL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="card__link"
                  >
                    Slides
                  </a>
                ) : (
                  ""
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
});

export default DayOne;
